import { useHubble } from '@seek/hubble';
import { useLayoutEffect } from 'react';

export const useSetHubblePage = (pageName: string) => {
  const hubble = useHubble();
  useLayoutEffect(() => {
    hubble.updateOptions({ pageName });
  }, [hubble, pageName]);
};
